import TeamEventMarket from './components/TeamEventMarket';
import AthleteMarket from './components/AthleteMarket';
import EventMarket from './components/EventMarket';
import AthleteTournamentMarket from './components/AthleteTournamentMarket';
import TeamEventList from './components/TeamEventList';
import TournamentMarket from './components/TournamentMarket';
import MatchMarket from './components/MatchMarket';
import TournamentList from './components/TournamentList';
import TeamTournamentMarket from './components/TeamTournamentMarket';
import OrderBookChart from './components/OrderBookChart';
import BestAvailableOrderCard from './components/BestAvailableOrderCard';
import OrderBookCard from './components/OrderBook';
import MyOrderList from './components/MyOrderList';
import ExternalPriceComparison from './components/ExternalPriceComparison';
import OrderGradeBar from './components/OrderGradeBar';
import MarketManager from './components/MarketManager';
import CreateMarketForm from './components/CreateMarketForm';
import ParlayCard from './components/Parlay/ParlayCard';

export default {
    TeamEventMarket,
    TeamTournamentMarket,
    AthleteMarket,
    BestAvailableOrderCard,
    EventMarket,
    OrderBookCard,
    CreateMarketForm,
    ParlayCard,
    MarketManager,
    OrderBookChart,
    AthleteTournamentMarket,
    TeamEventList,
    OrderGradeBar,
    ExternalPriceComparison,
    TournamentMarket,
    MatchMarket,
    TournamentList,
    MyOrderList
}